import React, { useEffect, useRef, useState } from "react";
import { PenLine, Eraser } from "lucide-react";

export const SignaturePad = ({ value, onChange, label = "Firma", testid = "signature-pad" }) => {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);

  useEffect(() => {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0f172a";
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return {
      x: (p.clientX - r.left) * (canvasRef.current.width / r.width),
      y: (p.clientY - r.top) * (canvasRef.current.height / r.height),
    };
  };
  const start = (e) => { setDrawing(true); const { x, y } = pos(e); const ctx = canvasRef.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(x, y); };
  const move = (e) => { if (!drawing) return; e.preventDefault(); const { x, y } = pos(e); const ctx = canvasRef.current.getContext("2d"); ctx.lineTo(x, y); ctx.stroke(); };
  const end = () => { if (!drawing) return; setDrawing(false); onChange(canvasRef.current.toDataURL("image/png")); };
  const clear = () => {
    const c = canvasRef.current; const ctx = c.getContext("2d");
    ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, c.width, c.height); onChange("");
  };

  return (
    <div className="border border-slate-300 rounded-lg p-2 bg-slate-50">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[11px] font-bold uppercase tracking-wider text-slate-600 flex items-center gap-1"><PenLine className="w-3.5 h-3.5" /> {label}</span>
        <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="text-[11px] text-slate-500 flex items-center gap-1"><Eraser className="w-3.5 h-3.5" /></button>
      </div>
      <canvas
        ref={canvasRef}
        data-testid={testid}
        width={520}
        height={150}
        className="w-full bg-white border border-slate-200 rounded touch-none"
        onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
        onTouchStart={start} onTouchMove={move} onTouchEnd={end}
      />
      {value ? <p className="text-[10px] text-emerald-600 mt-1 font-semibold">✓</p> : null}
    </div>
  );
};

export default SignaturePad;
